import BroadcastAnalyticsService from '../../services/broadcastsAnalytics'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {},

    // eslint-disable-next-line no-unused-vars
    getTotals({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getTotals(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getTransactions({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getTransactions(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getMppOpenRate({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getMppOpenRate(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getTotalsByPeriod({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getTotalsByPeriod(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getOpenClickByHour({ commit }, params) {
      return new Promise((resolve, reject) => {
          BroadcastAnalyticsService.getOpenClickByHour(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getTopClientsDevices({ commit }, params) {
      return new Promise((resolve, reject) => {
          BroadcastAnalyticsService.getTopClientsDevices(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getBroadcastsSentInPeriod({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getBroadcastsSentInPeriod(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getBroadcastErrors({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getBroadcastErrors(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },
    // eslint-disable-next-line no-unused-vars
    getBroadcastReceptorsActivity({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getBroadcastReceptorsActivity(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },

    // eslint-disable-next-line no-unused-vars
    getBroadcastReceptorsActivityExport({ commit }, params) {
      return new Promise((resolve, reject) => {
          BroadcastAnalyticsService.getBroadcastReceptorsActivityExport(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },

    // eslint-disable-next-line no-unused-vars
    getBroadcastsUsage({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getBroadcastsUsage(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    },

    // eslint-disable-next-line no-unused-vars
    getBroadcastItemsRevenueByPeriod({ commit }, params) {
      return new Promise((resolve, reject) => { 
          BroadcastAnalyticsService.getBroadcastItemsRevenueByPeriod(params).then(response=> {
          resolve(response.data)
      })
      .catch(error=>{ reject(error) })
      });
    }
}
